module.exports = __webpack_public_path__ + "static/media/3.23.f0d42603.png";